import { gpCommon } from '../app';
import { gpSetTelemetryUser } from '../util/telemetry';
import { IAuthorisationCheckerService, IAuthorisationCheckerService_serviceName } from './authorisation-checker-with-caching-service';

// The shell can only attribute telemetry to whoever the render itself was for,
// and signing in from #/login never reloads the page — so without this, every
// page view and event after that point keeps the identity the page was loaded
// with: anonymous, for the whole of a signup (#1345).
//
// Sign-out is read from the ABSENCE of a userId, not from loggedInStatus: no
// listener ever sees 'unauthorized'. Three sites notify, and none of them can
// produce it — resetCheckedStatus hardcodes 'notsure', the rendered-auth-seed
// path hardcodes 'authorized', and the network check rejects rather than
// resolves on the server's "no", its resolve path always carrying a truthy
// userId.
//
// Every sign-out runs login-service's logOut(), which ends by storing empty
// authorisation data and calling resetCheckedStatus(), so the last callback of a
// sign-out carries no userId and clears the identity. The resetCheckedStatus()
// earlier in that same method still reads the not-yet-removed data and
// re-notifies with the OLD userId, so the departing identity is re-set once
// before it goes.
//
// authorisationChanged also calls back immediately with the current status, so a
// page whose seed the app rejected is still named once the check it fell back to
// returns. That immediate status is 'notsure' either way, but not empty either
// way: on a signed-in page it carries the userId resetCheckedStatus read from
// storage, re-setting what the shell already set; on an anonymous page it is
// empty, and with nobody named yet it clears nothing.
gpCommon.run([
    IAuthorisationCheckerService_serviceName,
    function (authorisationChecker: IAuthorisationCheckerService) {
        authorisationChecker.authorisationChanged(status => {
            gpSetTelemetryUser(status.email, status.userId);
        });
    },
]);
